import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      className="design-iconfont"
    >
      <path d="M10.778 15.707c0 .809-.814 1.493-1.777 1.493-.964 0-1.778-.684-1.778-1.493V15.4h3.555v.307Zm5.797-2.82-1.6-1.624v-4.02c0-3.134-2.225-5.794-5.175-6.19a5.928 5.928 0 0 0-4.726 1.446 6.09 6.09 0 0 0-2.047 4.555v4.21l-1.6 1.623a1.481 1.481 0 0 0-.316 1.604c.227.552.754.909 1.344.909h2.99v.307C5.445 17.523 7.04 19 9 19c1.96 0 3.555-1.477 3.555-3.293V15.4h2.989c.59 0 1.117-.356 1.343-.91a1.482 1.482 0 0 0-.313-1.604Z" />
    </svg>
  )
}
const AlertIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
AlertIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-error-color))',
}
// 参数类型
AlertIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default AlertIcon
